module.exports = __webpack_public_path__ + "img/content_bg.02b020c.png";